<div class='component'>
	<div class='slider-viewport' #sliderViewport>
		<div class='slider-contents-wrapper' #sliderContentsWrapper [ngStyle]='{"margin-left.px": sliderLeftMargin}'>
			<ng-content></ng-content>
		</div>
	</div>
	<button mat-mini-fab color='' class='left-arrow' (click)='leftButton()' *ngIf='sliderLeftMargin < 0'>
		<mat-icon>arrow_left</mat-icon>
	</button>
	<button mat-mini-fab color='' class='right-arrow' (click)='rightButton()' *ngIf='sliderLeftMargin > minMargin'>
		<mat-icon>arrow_right</mat-icon>
	</button>
</div>
